import { render, staticRenderFns } from "./CloseConversation.vue?vue&type=template&id=0cdb08a0&"
import script from "./CloseConversation.vue?vue&type=script&lang=js&"
export * from "./CloseConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports